export default "__VITE_ASSET__B0PK2c3u__"